import { render } from "./BoxesArea.vue?vue&type=template&id=0d26ca32"
import script from "./BoxesArea.vue?vue&type=script&lang=js"
export * from "./BoxesArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__